import { Dispatch, SetStateAction } from 'react';
import { Input, Select } from 'antd';
import { TIME_DATATYPE } from '../../../../../../../../../constants/datatypes';
import { Comparator, Filter } from '../../../../../../../../../constants/types';
import { handleFilterSelect } from '../../../../../../utils';
import { formatAsFullDate } from '../../../../../../../../../utils/time';
import styles from './FilterSelector.module.scss';

export interface FilterSelectorProps {
  filter: Filter;
  filterByDate: boolean;
  filterValue: string;
  setFilterValue: Dispatch<SetStateAction<string>>;
  index: number;
  comparator: Comparator;
  modalFilters: Filter[];
  setModalFilters: (modalFilters: Filter[]) => void;
}

const FilterSelector = ({
  filter,
  filterByDate,
  filterValue,
  setFilterValue,
  index,
  comparator,
  modalFilters,
  setModalFilters,
}: FilterSelectorProps) => {
  const renderInput = filterByDate && !filter.listable;
  const onChange = (value: string) => {
    setFilterValue(value);
    const updatedModalFilters = handleFilterSelect(value, index, modalFilters, comparator);
    setModalFilters(updatedModalFilters);
  };

  return renderInput ? (
    <Input
      allowClear
      data-testid="filter-selector"
      onChange={e => onChange(e.target.value)}
    />
  ) : (
    <Select
      className={styles.filterSelector}
      data-testid="filter-selector"
      getPopupContainer={e => e}
      onChange={onChange}
      value={filter.datatype === TIME_DATATYPE ? formatAsFullDate(filterValue) : filterValue}
    >
      {filter.attributes.map(attribute => (
        <Select.Option key={attribute.value}>{attribute.value}</Select.Option>
      ))}
    </Select>
  );
};

export default FilterSelector;
